// extracted by mini-css-extract-plugin
module.exports = {"headerBlock":"header-module--header-block--2jwKg","header":"header-module--header--tFeG9"};